import { shadowInsetBorder, shadowPrimaryBottomLg } from '@fabric-ui/theme';

export interface FilterContext {
  filters: any;
  dateRange: Date[];
  typeMap: any;
}

export const getLast24HoursDate = (date: Date): Date => {
  const last24Hours = new Date(date);
  last24Hours.setHours(last24Hours.getHours() - 24);
  return last24Hours;
};

export const agentWidgetBoxStyle = cnt => ({
  flex: 1,
  borderRadius: '2px',
  backgroundColor: 'var(--color-surface-base-primary)',
  overflow: 'auto',
  flexShrink: 0,
  flexBasis: 'calc(25% - 16px)',
  minWidth: '345px',
  maxWidth: 'calc(25% - 16px)',
  boxShadow: shadowInsetBorder,
  background:
    cnt > 0 ? 'linear-gradient(180deg, var(--color-surface-base-primary) 50.16%, var(--color-surface-accent-blue-primary) 100%);' : 'none',
  border: '1px solid var(--color-border-base-subdued)',
  '&:hover': {
    boxShadow: shadowPrimaryBottomLg,
    cursor: 'pointer',
  },
});

export const agentDescription = {
  color: 'var(--color-content-base-secondary)',
  fontSize: '13px',
  p: 2,
  pb: 0,
  mb: 1,
  display: '-webkit-box',
  WebkitLineClamp: 3,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
  maxHeight: '70px',
  minHeight: '70px',
};
